<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="this.tablePath">付款管理列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">基本信息</span>
      <template slot="tools">
        <el-button v-if="!isReview"
                  size="mini"
                  type="primary"
                  @click="downloadPDF"
                  :loading="onDownloadDetail">生成PDF
        </el-button>
      </template>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="付款ID：">
              <span> {{id}} </span>
            </el-form-item>
            <el-form-item label="申请人："
                          prop="applicant_name">
              <span>{{form.applicant_name}} / {{form.applicant_real_name}}</span>
            </el-form-item>
            <el-form-item label="部门："
                          prop="department_name">
              <span>{{form.department_name}}</span>
            </el-form-item>
            <el-form-item label="付款类型："
                          prop="type">
              <span>{{type[form.type] || '批量付款'}}</span>
            </el-form-item>
            <el-form-item label="是否加急："
                          prop="is_urgent">
              <span>{{form.is_urgent ? '是' : '否'}}</span>
            </el-form-item>
            <el-form-item v-if="form.is_urgent === 1" label="期望日期："
                          prop="expected_date">
              <span>{{ form.expected_date | formatExpectedDate }}</span>
            </el-form-item>
            <el-form-item label="付款公司："
                          prop="payment_company">
              <span>{{paymentCompanys[form.payment_company]}}</span>
            </el-form-item>
            <el-form-item label="付款账户："
                          prop="payment_company" v-if="form.payment_company_account">
              <span>{{form.payment_company_account.name + '/' + form.payment_company_account.number}}</span>
            </el-form-item>
            <el-form-item label="付款说明："
                          prop="desc">
              <span>{{ form.desc }}</span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel v-if="!isBatch">
      <span slot="header">付款信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item v-if="form.type" label="付款主体"
                          prop="paid_to_type">
              <span>{{form.paid_to_type === 1 ? '对私' : '对公'}}</span>
            </el-form-item>
            <el-form-item label="收款对象名称："
                          prop="company_name">
              <!-- <remote-select
                v-if="form.paid_to_type === 2"
                :disabled="form.paid_to_type === 1"
                class="width-max"
                clearable
                allow-create
                id-key="id"
                label-key="company_name"
                value-key="id"
                v-model="form.company_bank_account_id"
                @change="payCompanyChange"
                placeholder="请输入收款对象名称搜索"
                :query-request="getCompanyAccounts"
                :find-request="getCompanyAccountsDetail">
              </remote-select> -->
              <span>{{form.company_name}}</span>
            </el-form-item>
            <el-form-item label="银行账号："
                          prop="bank_account">
              <span>{{form.bank_account}}</span>
            </el-form-item>
            <el-form-item label="开户银行支行："
                          prop="bank">
              <span>{{form.bank}}</span>
            </el-form-item>
            <el-form-item label="开户银行总行："
                          prop="bank_headquarters">
              <span>{{form.bank_headquarters}}</span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <layout-panel>
      <span slot="header">费用信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <el-row :gutter="20" style="margin-left: 0px">
          <el-col :span="1" class="col-center">序号</el-col>
          <el-col :span="2" class="col-center">项目编号</el-col>
          <el-col :span="3" class="col-center">费用承担部门</el-col>
          <el-col :span="2" class="col-center">一级科目</el-col>
          <el-col :span="2" class="col-center">二级科目</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票类型</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">税率%</el-col>
          <el-col :span="2" class="col-center">应付金额</el-col>
          <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票张数</el-col>
          <el-col :span="2" class="col-center">摘要</el-col>
          <!-- 财务审核后才显示 -->
          <el-col v-if="![1,2,3,4,13,14,].includes(form.status)" :span="2" class="col-center">财务摘要</el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2" class="col-center" style="color: red">*实付金额</el-col>
        </el-row>
        <br/>

        <el-row :gutter="20" v-for="(detailItem, itemIndex) in form.payment_detail"
                :key="itemIndex"
                class="invoice-row"
                style="margin-top:5px">
          <!--序号-->
          <el-col style="text-align: center" :span="1">
            {{itemIndex+1}}
          </el-col>
          <!-- 项目编号 -->
          <el-col key="project_id"
            :span="2">
            <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
          </el-col>
          <!-- 费用承担部门 -->
          <el-col key="department_name"
            :span="3">
            <span>{{detailItem.department_name}}</span>
          </el-col>

          <!--一级科目-->
          <el-col :span="2">
            <!-- 会计审批通过后都可修改 -->
            <el-select v-if="[5, 6, 7].includes(form.status * 1) && isReview" v-model="detailItem.first_subject" @change="val => firstSubjectChange(val, itemIndex)">
              <el-option v-for="(label, value) in firstSubjects"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
            <span v-else>{{detailItem.first_subject_name}}</span>
          </el-col>
          <!--二级科目-->
          <el-col :span="2">
             <!-- 会计审批通过后都可修改 -->
            <el-select v-if="[5, 6, 7].includes(form.status * 1) && isReview" v-model="detailItem.second_subject">
              <el-option v-for="(label, value) in secondSubjects[itemIndex]"
                        :key="value"
                        :label="label"
                        :value="Number(value)">
              </el-option>
            </el-select>
            <span v-else>{{detailItem.second_subject_name}}</span>
          </el-col>
          <!--发票类型-->
          <el-col v-if="showFeesInfoFileds" :span="2">
            <span>{{invoiceType[detailItem.invoice_type]}}</span>
          </el-col>
          <!--税率-->
          <el-col v-if="showFeesInfoFileds" :span="2" style="text-align:center;overflow: auto;">
            <span>{{ detailItem.invoice_type === 1 ? '-' : (taxRateType[detailItem.tax_rate] || (detailItem.tax_rate + '%')) }}</span>
          </el-col>
          <!--含税金额-->
          <el-col :span="2" style="text-align:center;overflow: auto;">
            <span>￥{{detailItem.amount | seperateThousandsToFixed(2)}}</span>
          </el-col>
          <!--发票张数-->
          <el-col v-if="showFeesInfoFileds" :span="2">
            <span>{{detailItem.invoice_count}}</span>
          </el-col>
          <!--摘要-->
          <el-col :span="2">
            <span style="word-break: break-all;">{{detailItem.desc}}</span>
          </el-col>
          <!--财务摘要-->
          <!-- 财务审核后才显示 -->
          <el-col v-if="![1,2,3,4,13,14].includes(form.status)" :span="2">
            <span style="word-break: break-all;">{{detailItem.finance_desc}}</span>
          </el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2">
            <span>{{detailItem.paid_amount}}</span>
          </el-col>
        </el-row>
        <br/>
        <el-row class="invoice-row" :gutter="20">
          <el-col :span="spanWithType">
            <p style="padding: 0; margin:0; text-align: right;">付款金额合计：</p>
          </el-col>
          <el-col :span="2">
            ￥{{totalAmount | seperateThousandsToFixed(2)}}
          </el-col>
          <el-col v-if="showFeesInfoFileds" :span="2">
            {{totalInvoiceCount}}
          </el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="4">
            <p style="padding: 0; margin:0; text-align: right;color: red;">实付金额合计：</p>
          </el-col>
          <el-col v-if="[8,9,10].includes(form.status)" :span="2" style="color: red">
            ￥{{totalPaidAmount | seperateThousandsToFixed(2)}}
          </el-col>
        </el-row>

        <el-form-item label="附件"
                      prop="attached_file">
          <div class="view-navbar">
            <ul class="clear-both">
              <li v-for="(item, index) in form.attached_file" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                  <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                  <i v-else
                      class="sj-icon-pdf"
                      style=" font-size:100px; margin-top: 50px"
                      @click="onGetPdfFile(item, index)"></i>
                </el-tooltip>
              </li>
            </ul>
          </div>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <span slot="header">审批人</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 100%">
            <el-form-item label="部门领导审批："
                          prop="department_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.department_approver_name}/${form.department_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <!-- approve_level -->
                  <span v-if="![11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 0" label="一级审批："
                          prop="first_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.first_approver_name}/${form.first_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <!-- approve_level -->
                  <span v-if="![1,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 1" label="二级审批："
                          prop="second_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.second_approver_name}/${form.second_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 2" label="三级审批："
                          prop="third_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.third_approver_name}/${form.third_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,3,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.approve_level > 3" label="四级审批："
                          prop="fourth_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.fourth_approver_name}/${form.fourth_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,3,4,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item v-if="form.is_urgent && form.special_approver" label="特批审批："
                          prop="fourth_approver">
              <el-row :gutter="20">
                <el-col :span="8">
                  <span>{{`${form.special_approver_name}/${form.special_approver_real_name || '-'}`}}</span>
                </el-col>
                <el-col :span="6">
                  <span v-if="![1,2,3,4,11,12,13,14].includes(form.status)" style="color: #67C23A">已审批通过</span>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="抄送人："
                          prop="cc">
              <el-row :gutter="20">
                <el-col :span="20">
                  <span style="white-space:pre-wrap; word-wrap: break-word;">{{form.cc_name}}</span>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
    <layout-panel>
      <span slot="header">付款信息</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="re-el-form__flex">
          <div class="medium" style="width: 100%">
            <el-form-item label="付款状态："
                          prop="status">
              <span>{{status[form.status]}}</span>
            </el-form-item>
            <el-form-item label="实付金额合计："
                          prop="paid_amount_total">
              <span>{{form.paid_amount_total}}</span>
            </el-form-item>
            <el-form-item label="日志："
                          prop="log">
              <span style="white-space:pre-wrap;">{{form.log}}</span>
            </el-form-item>
            <el-form-item label="付款结果附件："
                          v-if="[8, 9, 10].includes(form.status * 1)"
                          prop="paid_attached_file">
              <div class="view-navbar">
                <ul class="clear-both">
                  <li v-for="(item, index) in form.paid_attached_file" :key="index">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                      <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                      <i v-else
                         class="sj-icon-pdf"
                         style=" font-size:100px; margin-top: 50px"
                         @click="onGetPdfFile(item, index)"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-form-item>

            <el-form-item label="驳回原因：">
              <el-input placeholder="驳回时请填写，通过无需填写" v-model="reason" :disabled="!allowReview"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onReview(true)" :disabled="!allowReview">通过</el-button>
              <el-button type="danger" @click="onReview(false)" :disabled="!allowReview">驳回</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
    <!-- 冲销信息 -->
    <template v-if="[8,10].includes(form.status) && isPrepaymentType">
      <PaymentWriteOffInfo
        :collapse="!isReview"
        :form="form"
        :projectNames="projectNames"/>
    </template>

    <layout-panel v-if="[8,10].includes(form.status)" :collapse="!isReview">
      <span slot="header">退款信息</span>
      <el-form size="medium"
               label-width="120px">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="可退款金额："><span> ￥{{ (form.paid_amount_total - form.refund_amount_total) | seperateThousandsToFixed(2) }} </span></el-form-item>
            <el-form-item label="已退款金额："><span> ￥{{ form.refund_amount_total | seperateThousandsToFixed(2) }} </span></el-form-item>
            <el-form-item label="退款记录：">
              <span v-for="log in form.refund_detail" :key="log.id" style="display: block">
                {{ `${log.created_at} ${log.creator_name} 退款 ￥${log.refund_amount_total} ` }}
                <router-link :to="`/payment-refund/customer/detail/${log.id}`">
                  <span>{{`退款条目ID：${log.id}`}}</span>
                </router-link>
              </span>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>

    <el-button v-if="!isReview" type="primary" @click="$router.back()">返回</el-button>
    <el-button v-if="!isReview && canGoReview" type="warning" @click="goReview">审核</el-button>
    <attached-file :visible="attach_file_visible"
                    :file_title="file_title"
                    :url="attach_file_url"
                    @closeDialog="closeDialog"></attached-file>
    </template>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import { formRules, writeOffFormRules } from '../payment-manager.rules.js'
import downloadJS from '@/vendor/download'
import { getToken } from '@utils/auth'
import { checkReviewPermissionWithUser } from '../payment-manager-check-permission'
import moment from 'moment'
import AttachedFile from '@/views/payment-manager/components/AttachedFile'
import PaymentWriteOffInfo from '../components/PaymentWriteOffInfo'
import ErrorPanel from '@/components/ErrorPanel'

export default {
  components: {
    AttachedFile,
    PaymentWriteOffInfo,
    ErrorPanel,
  },
  filters: {
    formatExpectedDate (date) {
      return moment(date).format('YYYY-MM-DD')
    }
  },
  data () {
    return {
      id: 0,
      formRules,
      writeOffFormRules,
      onDownloadDetail: false,
      detailErrorMsg: false,
      showErrorMsg: true,
      fileList: [],
      userDetail: {},
      form: {
        approve_level: null,
        applicant_name: '',
        applicant_real_name: '',
        department_id: null,
        department_name: null,
        bank_account_snapshot: {
          name: null,
          bank_account: null,
          bank: null,
          bank_headquarters: null,
          remark: null,
        },
        desc: null,
        type: null,
        status: null,
        is_urgent: 0,
        payment_company: null,
        payment_company_account: {
          id: 0,
          name: '',
          number: ''
        },
        paid_to_type: 0,
        user_bank_account_id: '', // 对私付款，用户账户信息 id
        company_bank_account_id: '', // 对公付款，公司账户信息 id，为0时创建新的对公付款账户信息
        company_name: null,
        bank_account: null,
        bank: null,
        bank_headquarters: null,
        current_approver: null,
        department_approver: null,
        department_approver_name: null,
        department_approver_real_name: null,
        first_approver: null,
        first_approver_name: null,
        first_approver_real_name: null,
        second_approver: null,
        second_approver_name: null,
        second_approver_real_name: null,
        third_approver: null,
        third_approver_name: null,
        third_approver_real_name: null,
        fourth_approver: null,
        fourth_approver_name: null,
        fourth_approver_real_name: null,
        special_approver: null,
        special_approver_name: null,
        special_approver_real_name: null,
        cc: null,
        cc_name: null,
        expected_date: '',
        apply_amount: null,
        paid_amount_total: null,
        payment_detail: [{
          project_id: null,
          project_number: null,
          department_id: null,
          department_name: null,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
          paid_amount: null,
          finance_desc: null,
        }],
        attached_file: [],
        paid_attached_file: [],
        log: null,
        write_off_lists: [],

        // 退款
        refund_amount_total: null,
        refund_detail: [],
        refund_log: null,

        // 冲销
        written_off_amount: null,
      },
      firstSubjects: {},
      secondSubjects: [{}],
      writeOffSecondSubjects: [{}],
      projectNames: {},
      first_approver: null,
      second_approver: null,
      third_approver: null,
      fourth_approver: null,
      reason: null,
      paid_date: null,
      // 冲销
      writeOffForm: {
        attached_file: [],
        amount: null,
        write_off_detail: [{
          project_id: null,
          project_number: null,
          department_id: null,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
          canSelectDepartment: true,
        }],
      },
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
      selectItem: {},
      attach_file_visible: false,
      file_title: '',
      attach_file_url: '',

      originFirstSubjects: null,
      originSecondSubjects: null,
      associatedRelationships: null,
      writeOffAssociatedRelationships: null,

      canGoReview: false,
      paymentCompanys: {},
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
      type: state => state.paymentManager.type,
      status: state => state.paymentManager.status,
      invoiceType: state => state.paymentManager.invoiceType,
      taxRateType: state => state.paymentManager.taxRateType,
    }),
    totalAmount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
    },
    totalInvoiceCount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
    totalPaidAmount () {
      return this.form.payment_detail.reduce((total, item) => {
        return total + Number(item.paid_amount)
      }, 0)
    },
    spanWithType () {
      if (this.isBatch) {
        return 10
      } else {
        if (this.form.status === 7) {
          // return 11
          return 14
        }
        if (this.isPrepaymentType || this.showWriteOffForm) {
          return 10
        }
      }
      return 14
      // if (this.isBatch) {
      //   return 12
      // } else {
      //   if (this.isPrepaymentType) {
      //     return 11
      //   }
      // }
      // return 16
    },
    showFeesInfoFileds () {
      if (this.isBatch) {
        return false
      } else {
        return !this.isPrepaymentType
      }
    },
    isBatch () {
      return this.form.type === 4
    },
    isReview () {
      return this.$route.meta.isReview
    },
    isPrepaymentType () {
      return this.form.type === 3
    },
    tablePath () {
      if (this.$route.query.from && this.$route.query.from === 'approval') {
        return '/payment-manager/approval'
      } else {
        if (this.$route.meta.isApproval) {
          return '/payment-approval/table'
        }
        return '/payment-manager/table'
      }
    },
    allowReview () {
      return [1, 2, 3, 4, 13, 14].includes(this.form.status) && this.checkReviewPermission(this.form) && this.$route.meta.isReview
    }
  },
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {
  },
  mounted () {},
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
      'getPlatformUsersIndex',
      'getPlatformUsersDetail',
    ]),
    async onLoad () {
      await this.getFinCenterConfigs()
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      } else {
        this.fetchUserDetail('getuserAccountDetailByUserID', {id: this.user.id})
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      let api = 'getPaymentManagerDetail'
      if (this.$route.meta.isApproval) {
        api = 'getPaymentDetailFinanceApi'
      }
      request(api, {id}).then(async ({data}) => {
        await this.setupProjectNames(data)
        filter.setLoop(this.form, data)
        this.form.paid_attached_file = data.paid_attached_file || []
        // this.fileList = data.attached_file
        this.setupLog(data)
        this.setupSubjects(data)
        this.setupAttachedFile()
        this.fetchPlatformUsersWithCCids(data)
        this.setupOtherData(data)
        this.setupWriteOffDetail(data)

        this.setupCanGoReview(data)
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
    setupCanGoReview (data) {
      if (this.$route.meta.isApproval) { // 财务管理进入查看详情
        if ([5, 6].includes(data.status)) {
          // 当前用户为 超管/财务管理员， usertype == 1 或者 usertype ==5
          if (this.user.usertype * 1 === 1) {
            this.canGoReview = true
          } else if (this.user.usertype * 1 === 5) { // 财务管理员 需要校验权限
            const params = {
              id: this.id,
              is_test_permission: 1
            }
            let uri = 'accountantReviewPaymentApplication'
            if ([6].includes(data.status)) {
              uri = 'managerReviewPaymentApplication'
            }
            request.loading(uri, params).then(res => {
              this.canGoReview = true
            }).catch((_) => {
              this.canGoReview = false
            })
          }
        }
      } else { // 客户管理进入
        if ([1, 2, 3, 4, 13, 14].includes(data.status)) {
          // 当前用户为 超管 或者 current_approver = 当前用户id
          this.canGoReview = (this.user.usertype * 1 === 1) || (data.current_approver === this.user.id * 1)
        }
      }
    },
    setupLog (data) {
      this.form.log = data.log.reduce((total, item) => {
        return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
      }, '')
    },
    setupSubjects (data) {
      const firstSubjectIds = this.associatedRelationships[this.form.type]
      const firstSubjects = {}
      for (const id in firstSubjectIds) {
        firstSubjects[id] = this.originFirstSubjects[id]
      }
      this.firstSubjects = firstSubjects

      data.payment_detail.forEach((item, index) => {
        const secondSubjects = {}
        const secondSubjectIds = firstSubjectIds[item.first_subject]
        for (const index in secondSubjectIds) {
          const id = secondSubjectIds[index]
          secondSubjects[id] = this.originSecondSubjects[id]
        }
        this.secondSubjects[index] = secondSubjects

        // 当一级科目被禁用的时候，需要重置为 null
        if (!this.firstSubjects[item.first_subject]) {
          item.first_subject = null
        }

        // 当二级科目被禁用的时候，需要重置为 null
        if (!secondSubjects[item.second_subject]) {
          item.second_subject = null
        }
      })
    },
    setupProjectNames (data) {
      let reqProjectApis = []
      this.projectNames = {
        '0': '无'
      }
      data.payment_detail.forEach((item, index) => {
        item.project_id = item.project_id + ''
        reqProjectApis.push(item.project_id)
      })
      data.write_off_lists.forEach(writeOff => {
        writeOff.write_off_detail.forEach((item, index) => {
          item.project_id = item.project_id + ''
          reqProjectApis.push(item.project_id)
        })
      })
      reqProjectApis = _.uniq(reqProjectApis)
      reqProjectApis = reqProjectApis.filter(item => item > 0).map(id => request('getProjectDetail', {id: id}))
      return request.all.common(reqProjectApis).then(res => {
        res.map(item => {
          if (item.data.name && item.data.number) {
            this.projectNames[item.data.id] = item.data.name
            // return item.data.name + '/' + item.data.number
          }
          // return '无'
        })
      })
    },
    setupAttachedFile () {
      // 申请的 附件
      this.form.attached_file.forEach((file, index) => {
        if (file.type === 'pic') {
          request.common('getFinCenterFileUrl', file).then((res) => {
            this.$set(this.form.attached_file[index], 'pic_url', res.data)
          })
        }
      })
      // 付款附件
      this.form.paid_attached_file.forEach((file, index) => {
        if (file.type === 'pic') {
          request.common('getFinCenterFileUrl', file).then((res) => {
            this.$set(this.form.paid_attached_file[index], 'pic_url', res.data)
          })
        }
      })
      // 冲销附件
      this.form.write_off_lists.forEach((item, index) => {
        item.attached_file.forEach((file, subIndex) => {
          if (file.type === 'pic') {
            request.common('getFinCenterFileUrl', file).then((res) => {
              this.$set(this.form.write_off_lists[index].attached_file[subIndex], 'pic_url', res.data)
            })
          }
        })
      })
    },
    fetchPlatformUsersWithCCids (data) {
      if (data.cc.length > 0) {
        const adminuserIds = [...data.cc]
        const ccNames = []
        request.common('fetchApproverRealName', {user_id: adminuserIds}).then((res) => {
          res.data.forEach(item => {
            ccNames.push(`${item.user_name}/${item.name || '-'}`)
          })
          this.form.cc_name = ccNames.join('\t')
        })
      } else {
        this.form.cc_name = '无'
      }
    },
    setupOtherData (data) {
      if (data.paid_to_type === 1) {
        this.fetchUserDetail('getUserBankAccountById', {id: data.user_bank_account_id})
      }
      if ([8, 10].includes(data.status)) {
        // this.form.write_off = data.write_off_lists.reduce((total, item) => {
        //   return total + Number(item.amount)
        // }, 0)
        this.form.wait_write_off = this.form.paid_amount_total - this.form.written_off_amount
      }
      if (this.form.paid_to_type === 2) {
        this.getCompanyAccountsDetail(data)
        // this.getCompanyAccountsDetail({id: this.form.company_bank_account_id})
      }
    },
    setupWriteOffDetail (data) {
      data.payment_detail.forEach((item, index) => {
        if (this.writeOffForm.write_off_detail.length === index) {
          this.addDetailItem()
        }
        this.writeOffFirstSubjectChange(item.first_subject, index)
        const writeOffDetail = this.writeOffForm.write_off_detail[index]
        writeOffDetail.project_id = item.project_id
        writeOffDetail.project_number = item.project_number
        writeOffDetail.department_id = item.department_id
        writeOffDetail.first_subject = item.first_subject
        writeOffDetail.second_subject = item.second_subject
        writeOffDetail.amount = item.amount
        writeOffDetail.desc = item.desc
        if (item.project_number) {
          if (item.project_number[0] === 'H') {
            writeOffDetail.canSelectDepartment = true
          } else {
            writeOffDetail.canSelectDepartment = false
          }
        } else {
          writeOffDetail.canSelectDepartment = true
        }
        if (parseInt(item.project_id) === 0) {
          writeOffDetail.project_id = null
        }
        if (parseInt(item.department_id) === 0) {
          writeOffDetail.department_id = null
        }
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    getWriteOffForm () {
      const writeOffForm = filter.copyJson(this.writeOffForm)
      if (writeOffForm.invoice_type === 1) {
        writeOffForm.tax_rate = 0
      }
      return writeOffForm
    },
    onSubmit () {
      if (this.writeOffForm.amount > this.form.wait_write_off) {
        this.$message.error('冲销金额不得大于该付款申请的待冲销金额')
        return
      }
      this.$refs['writeOffForm'].validate((valid) => {
        if (valid) {
          this.writeOffApplication(this.id)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    writeOffApplication (id) {
      request.common('writeOffApplication', {id, ...this.getWriteOffForm()}).then((res) => {
        this.$confirm('冲销成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.setForm(this.id)
          this.$refs.writeOffForm.resetFields()
          this.$refs.upload.clearFiles()
        }, () => {
          this.$router.push({path: this.tablePath})
        })
      })
    },
    onViewImage (event) {
      if (event.target.src) {
        this.views = new Viewer(event.target, {
          url: (image) => event.target.src,
        })
      }
      this.views.view()
    },
    onGetPdfFile (item) {
      this.$confirm('下载查看文件', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '下载',
        cancelButtonText: '查看',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
          'SJ-Auth-Token': getToken()
        })
      }).catch(action => {
        if (action === 'cancel') {
          this.tryOpenAttachFile(item)
        }
      })
    },
    tryOpenAttachFile (item) {
      if (item.type === 'pdf') {
        request.common('getFinCenterFileUrl', item).then(({data}) => {
          window.open(data)
        })
      } else if (item.type === 'eml') {
        this.attach_file_url = request.items.getFinCenterFileUrlForDownload(item)
        this.file_title = item.title
        this.attach_file_visible = true
      } else {
        this.$message({
          type: 'error',
          message: '暂不支持预览操作',
        })
      }
    },
    closeDialog () {
      this.attach_file_visible = false
    },
    fetchUserDetail (uri, params) {
      request.common(uri, params).then(({data}) => {
        if (this.$route.params.id) {
          if (this.form.paid_to_type === 1) {
            this.form.user_bank_account_id = data.id
            this.form.company_name = data.name
            this.form.bank_account = data.bank_account
            this.form.bank = data.bank
            this.form.bank_headquarters = data.bank_headquarters
          }
        } else {
          this.form.department_id = data.id
          this.userDetail = data
          this.form.first_approver = data.first_approver
          this.form.second_approver = data.second_approver
          this.form.third_approver = data.third_approver
          this.form.fourth_approver = data.fourth_approver
        }
      })
    },
    getFinCenterConfigs () {
      return request.common('getFinCenterConfigs').then(({data}) => {
        this.setupSubjectsFromFinCenterConfigs(data)
        this.setupPaymentCompany(data)
      })
    },
    setupSubjectsFromFinCenterConfigs (data) {
      this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
      this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
      this.associatedRelationships = data.payment_apply_subject_map
      this.writeOffAssociatedRelationships = data.payment_write_off_subject_map
    },
    setupPaymentCompany (data) {
      this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
        o[k.id] = k.name
        return o
      }, {})
    },
    expandData (data) {
      // data = data.filter(item => { return item.is_disabled < 1 })
      let result = {}
      for (const dataKey in data) {
        const tmp = data[dataKey]
        result[tmp.id] = tmp.name
      }
      return result
    },
    getCompanyAccounts (key) {
      return request.common('getCompanyBankAccountTable', {company_name: key.keyword})
    },
    getCompanyAccountsDetail (data) {
      // request.common('getCompanyBankAccountById', id).then(data => {
      this.form.company_name = data.bank_account_snapshot.company_name
      this.form.bank_account = data.bank_account_snapshot.bank_account
      this.form.bank = data.bank_account_snapshot.bank
      this.form.bank_headquarters = data.bank_account_snapshot.bank_headquarters
      // })
    },
    removeDetailItem (index) {
      this.writeOffForm.write_off_detail.splice(index, 1)
    },
    addDetailItem () {
      this.writeOffForm.write_off_detail.push(
        {
          project_id: null,
          project_number: null,
          department_id: null,
          first_subject: null,
          second_subject: null,
          invoice_type: null,
          tax_rate: null,
          amount: null,
          invoice_count: null,
          desc: null,
        }
      )
      this.secondSubjects.push({})
    },
    changeProject (val, index) {
      this.form.payment_detail[index].project_id = val.id
      this.form.payment_detail[index].project_number = val.number
    },
    downloadPDF () {
      this.onDownloadDetail = true
      downloadJS(request.items.exportPaymentApplicationPDF({id: this.id}), false, false, {
        'SJ-Auth-Token': getToken()
      }, () => {
        this.onDownloadDetail = false
      })
    },
    firstSubjectChange (val, index) {
      this.form.payment_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.associatedRelationships[this.form.type][val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.secondSubjects[index] = secondSubjects
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    onChangeFile (file, fileList, formField) {
      let isLt5M = file.raw.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('文件内容必须小于5MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      let formData = new FormData()
      formData.append('file', file)
      this.id && formData.append('apply_id', this.id)
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type = file.name.split('.').pop().toLowerCase()
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic'
        } else if (['pdf'].includes(type)) {
          type = 'pdf'
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml'
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office'
        }
        if (index > -1) {
          formField[index] = {name: file.name, url: data, type: type}
        }
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
      })
    },
    review (uri, params) {
      request.common(uri, params).then((res) => {
        this.$confirm('审核成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: this.tablePath})
        }, () => {
          this.setForm(this.id)
        })
      })
    },
    reviewURIandParams () {
      let uri = ''
      const params = {id: this.id}
      if ([1, 2, 3, 4, 13, 14].includes(this.form.status)) {
        uri = 'reviewPaymentApplication'
      } else {
        if (this.form.status === 5) {
          uri = 'accountantReviewPaymentApplication'
        } else if (this.form.status === 6) {
          uri = 'managerReviewPaymentApplication'
        }
        params.payment_detail = this.getPaymentDetailforSubmit()
      }
      return {uri, params}
    },
    onReview (status) {
      const {uri, params} = this.reviewURIandParams()
      if (status) {
        this.$confirm('确认审核通过吗？', '审核通过', {type: 'warning'}).then(() => {
          params.is_rejected = 0
          this.review(uri, params)
        })
      } else {
        if (this.reason && this.reason.length > 0) {
          params.is_rejected = 1
          params.reason = this.reason
          this.review(uri, params)
        } else {
          this.$message.error('请输入驳回原因')
        }
      }
    },
    onPayment () {
      const params = {
        id: this.id,
        paid_date: this.paid_date,
        payment_detail: this.getPaymentDetailforSubmit()
      }
      this.$confirm('确认付款吗？', '付款', {type: 'warning'}).then(() => {
        request.common('paymentApplication', params).then((res) => {
          this.$confirm('付款成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
            this.$router.push({path: this.tablePath})
          }, () => {
            this.setForm(this.id)
          })
        })
      })
    },
    getPaymentDetailforSubmit () {
      return this.form.payment_detail.map(item => {
        return {
          id: item.id,
          first_subject: item.first_subject,
          second_subject: item.second_subject,
          paid_amount: item.paid_amount
        }
      })
    },
    writeOffFirstSubjectChange (val, index) {
      this.writeOffForm.write_off_detail[index].second_subject = null
      const secondSubjects = {}
      const secondSubjectIds = this.writeOffAssociatedRelationships[val]
      for (const index in secondSubjectIds) {
        const id = secondSubjectIds[index]
        secondSubjects[id] = this.originSecondSubjects[id]
      }
      this.writeOffSecondSubjects[index] = secondSubjects
    },
    writeOffInvoiceTypeChange (val, index) {
      if (val === 1) {
        this.writeOffForm.write_off_detail[index].tax_rate = 0
      } else {
        this.writeOffForm.write_off_detail[index].tax_rate = null
      }
    },
    writeOffTotalAmount (index) {
      const writeOff = this.form.write_off_lists[index]
      return writeOff.write_off_detail.reduce((total, item) => {
        return total + Number(item.amount)
      }, 0)
    },
    writeOffTotalInvoiceCount (index) {
      const writeOff = this.form.write_off_lists[index]
      return writeOff.write_off_detail.reduce((total, item) => {
        return total + Number(item.invoice_count)
      }, 0)
    },
    onCancel () {
      this.$router.push({path: this.tablePath})
    },
    checkReviewPermission (row) {
      return checkReviewPermissionWithUser(row, this.user)
    },
    goReview () {
      if (this.$route.meta.isApproval) {
        this.$router.push(`/payment-approval/review/${this.id}`)
      } else {
        this.$router.push(`/payment-manager/review/${this.id}`)
      }
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.col-center {
  text-align:center
}
.invoice-row .el-col {
  line-height: 30px;
  text-align: center;
}

.view-navbar {
  right: 0px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  display: inline;
  float: left;

  ul {
    transform: translateX(0px);
    transition: all 0.3s;
    box-sizing: content-box;
    // height: 100px;
    overflow: hidden;
    padding: 1px 0;

    li {
      float: left;
      list-style: none;
      width: 100px;
      height: 100px;
      margin-right: 5px;
      cursor: pointer;
      font-size: 0;
      line-height: 0;
      overflow: hidden;
      transition: opacity 0.15s;
    }
  }
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/payment-manager/pages/PaymentManagerReview.vue